module.exports = __webpack_public_path__ + "static-v-shop/1765543028354/img/36377.1b00dd14.jpg";